import { DataConfig } from '@aibees/elephant/components/sortable-table';
import { ElephantPresetType } from '@aibees/elephant/types';
import {
  useBrowsePresetApi,
  useUpdatePresetMutationApi,
} from '@aibees/shared/api';
import { ParsedPreset } from '@aibees/shared/definition';
import { useNotify } from '@aibees/shared/hooks';
import { baseQueryClient } from '@aibees/shared/http/base-query-client';

export function useUpdateStatusBuyingTeamApi(item: ParsedPreset<DataConfig>) {
  const api = useUpdatePresetMutationApi(item.id);
  const type = ElephantPresetType.BUYING_TEAM_MATRIX;
  const notify = useNotify();

  const updateBuyingTeamStatus = () => {
    return api
      .mutateAsync({
        type,
        name: item.name,
        value: { ...item.value, active: !item.value.active },
      } as any)
      .then(() => {
        baseQueryClient.invalidateQueries([
          useBrowsePresetApi.name,
          ElephantPresetType.BUYING_TEAM_MATRIX,
        ]);

        notify.success(
          `The buying team "${item.name}" ${
            item.value.active ? 'deactivated' : 'activated'
          } successfully.`
        );
      });
  };
  return { updateBuyingTeamStatus, isLoading: api.isLoading };
}
